import axios from 'axios'
import router from '../../router'
const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  apiMemInfo (context, payload) {
    // console.log(payload)
    if (payload.flag === 'INSERT') {
      // console.log(payload)
      axios.post('/api/signin', payload)
        .then((response) => {
          // console.log(response)
          sessionStorage.setItem('token', 'Bearer ' + response.data.token)
          sessionStorage.setItem('name', response.data.name)
          sessionStorage.setItem('timestamp', payload.timestamp)
          router.push('/')
        })
        .catch((error) => {
          console.log(error.response.data)
          alert('로그인 중 오류가 발생하였습니다. 다시 시도해주세요.')
        })
    } else if (payload.flag === 'ADMIN') {
      axios.post('/api/adminsignin', payload)
        .then((response) => {
          // console.log(response)
          sessionStorage.setItem('token', 'Bearer ' + response.data.token)
          sessionStorage.setItem('timestamp', payload.timestamp)
          router.push('/RecommendedItems')
        })
        .catch((error) => {
          if (error.response.status === 500) {
            alert('ID 혹은 비밀번호 오류 입니다.')
          }
        })
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js